"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _layout = _interopRequireDefault(require("../attrs/layout"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledPaper = (0, _styledComponents["default"])(_material.Paper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  padding: 20px;\n  width: 100%;\n  display: flex;\n  height: ", "px;\n  z-index: 2;\n  flex-direction: row;\n  justify-content: space-between;\n\n  &.MuiPaper-elevation1 {\n    &.withoutShadow {\n      box-shadow: inset 0px -1px 0px rgba(177, 183, 197, 0.3);\n    }\n  }\n"])), _layout["default"].pageHeaderBarHeight);
var OptionalHidden = function OptionalHidden(_ref) {
  var children = _ref.children,
    alwaysVisible = _ref.alwaysVisible;
  return alwaysVisible ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children) : /*#__PURE__*/_react["default"].createElement(_material.Hidden, {
    smDown: true
  }, children);
};
var PageHeader = function PageHeader(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    alwaysVisible = _ref2.alwaysVisible;
  return /*#__PURE__*/_react["default"].createElement(OptionalHidden, {
    alwaysVisible: alwaysVisible
  }, /*#__PURE__*/_react["default"].createElement(StyledPaper, {
    square: true,
    className: className
  }, children));
};
PageHeader.propTypes = {
  children: _propTypes["default"].node.isRequired,
  alwaysVisible: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
PageHeader.defaultProps = {
  alwaysVisible: false,
  className: ''
};
var _default = exports["default"] = PageHeader;